/**
 * NAIVE one-tap size add.
 *
 * Product cards render a row of size buttons inside a single <form> that lives in
 * a <product-form-component>. Each button is a submit button, so this listener runs
 * in the capture phase — before the submit event — and writes the clicked size's
 * variant id into the form's hidden `id` input. The theme's own product-form
 * component then handles the add and opens the cart drawer.
 */
(function () {
  if (window.__naiveCardAdd) return;
  window.__naiveCardAdd = true;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var pill = target.closest('.naive-add__pill');
      if (!pill || pill.disabled) return;

      var form = pill.closest('form');
      if (!form) return;

      var variantId = pill.getAttribute('data-variant-id');
      var input = form.querySelector('input[name="id"]');
      if (input && variantId) input.value = variantId;

      var row = pill.closest('.naive-add__row');
      if (row) {
        var selected = row.querySelectorAll('.naive-add__pill[data-selected]');
        for (var i = 0; i < selected.length; i++) selected[i].removeAttribute('data-selected');
      }

      pill.setAttribute('data-selected', 'true');
      window.setTimeout(function () {
        pill.removeAttribute('data-selected');
      }, 1400);

      // Open the cart drawer for immediate feedback. Horizon only auto-opens when
      // the auto_open_cart_drawer setting is on, and its own guard is the same
      // isOpen check, so calling it here is safe either way.
      window.setTimeout(function () {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
          try {
            drawer.open();
          } catch (error) {
            /* drawer not upgraded yet - the theme will open it when the add resolves */
          }
        }
      }, 80);
    },
    true
  );
})();
